import React, { Component } from 'react';
import { Provider } from "react-redux";
import store from "../../store-basic";
import CustomRoute from "../../components/customRoute/customRoute";

const App = () => {
	return (
		<Provider store={store}>
			<CustomRoute/>
		</Provider>
	);
};

export default App;
